<template>

    <!-- <div class="countdown  display-2 d-inline-flex  float-md-left">
       -->
       <div class="countdown">
          <div class="block">
            <p class="digit">{{ days | two_digits }}</p>
            <p class="text">{{$t('Days')}}</p>
          </div>
          <div class="block">
            <p class="digit">{{ hours | two_digits }}</p>
            <p class="text">{{$t('Hours')}}</p>
          </div>
      
      
          <div class="block">
            <p class="digit">{{ minutes | two_digits }}</p>
            <p class="text">{{$t('Minutes')}}</p>
          </div>
          <div class="block">
            <p class="digit">{{ seconds | two_digits }}</p>
            <p class="text">{{$t('Seconds')}}</p>
          </div>
      </div>
   
 
</template>
<script>
export default {
    name:"Countdown",
    mounted() {
                window.setInterval(() => {
                    this.now = Math.trunc((new Date()).getTime() / 1000);
                },1000);
            },
    props: {
            date: {
                    type: String
                }
            },
    data() {
            return {
                    now: Math.trunc((new Date()).getTime() / 1000)
                 }
            },
    computed: {
                dateInMilliseconds() {
                    return Math.trunc(Date.parse(this.date) / 1000)
                },
                seconds() {
                    return (this.dateInMilliseconds - this.now) % 60;
                },
                minutes() {
                    return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
                },
                hours() {
                    return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
                },
                days() {
                    return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
                }
            },
  
    filters:{
                two_digits: function( value){
                    if (value < 0) {
                            return '00';
                    }
                    if (value.toString().length <= 1) {
                            return `0${value}`;
                    }
                    return value;
                 }
            }
}
</script>
<style scoped>


.countdown {

  display: flex;
}

.block {
    display: flex;
    flex-direction: column;
    margin: 20px;
}

.text {
    color: #055d74;
    
    font-family: 'Cinzel Decorative', cursive;
    
    font-weight: 40;
    margin-top:10px;
    margin-bottom: 10px;
    text-align: center;
}

.digit {
    color: #055d74;
    
    font-weight: 100;
    font-family: 'Cinzel Decorative', cursive;
    margin: 10px;
    text-align: center;
}
@media screen and (max-width: 600px) {
  .text  {
     font-size: 12px;
  }
  .digit {
     font-size: 18px;
  }
}
@media screen and (min-width: 1200px) {
  .text {
     font-size: 36px;
  }
  .digit {
     font-size: 72px;
  }
}
  
</style>